import { Component, OnInit, Input, ContentChild, ElementRef } from '@angular/core';
import { MbValidationDirective } from '../directives/mb-validation.directive';
import { NgControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-mb-form-field',
  templateUrl: './mb-form-field.component.html',
  styleUrls: ['./mb-form-field.component.scss']
})
export class MbFormFieldComponent implements OnInit  {

  @Input() title;
  @Input() wrap: boolean;
  @Input() misfit: boolean;
  @Input() preicon: boolean;
  @Input() posticon: boolean;
  @Input() lowercase: boolean;
  @Input() fullWidth: boolean;
  @Input() rightItem: string;
  @Input() mini: boolean;
  @ContentChild(MbValidationDirective, {read: NgControl, static: false}) validation: FormControl;
  @ContentChild(MbValidationDirective, {read: NgControl, static: false}) element: ElementRef;

  constructor() { }

  ngOnInit() {
  }
}
